// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2gPif","label":"Completed_label__2Zzca"};